import localforage from "localforage";

const DEFAULT_OPTIONS = {
  forceRefresh: false,
  clearCookies: false,
  clearCache: false,
  clearBrowserStorage: false,
  clearGlobalState: false,
};

export const clearCache = async (options = DEFAULT_OPTIONS) => {
  let {forceRefresh, clearCookies, clearCache, clearBrowserStorage, clearGlobalState} = {
    ...DEFAULT_OPTIONS,
    ...options,
  };

  const loadedNewStorage = Boolean(localStorage.getItem("loadedNewStorage") === "true");
  const mustRefresh = (clearBrowserStorage || clearGlobalState) && !loadedNewStorage;
  forceRefresh = options.forceRefresh || mustRefresh;

  try {
    if (!loadedNewStorage && clearBrowserStorage) {
      localStorage.clear();
    }

    if (clearCookies) {
      const cookies = document.cookie;
      for (const cookie of cookies.split(";")) {
        const [name, value] = cookie.split("=");
        document.cookie =
          name +
          `=;path=/;domain=.${window.config.isDev && window.location.hostname == "localhost" ? "localhost" : (window.config.domain ?? "")};max-age=0`;
      }
    }

    if (clearCache && "caches" in window) {
      caches
        .keys()
        .then(function (cacheNames) {
          cacheNames?.forEach(async function (cacheName) {
            const cache = await caches.open(cacheName);
            const requests = await cache.keys();

            for (const request of requests) {
              if (request.url.includes("/assets/index-") && request.url.endsWith(".js")) {
                await cache.delete(request);
                break;
              }
            }
          });
        })
        .catch(function (error) {
          console.error("Error:", error);
        });
    }

    if (!loadedNewStorage && clearGlobalState) {
      await localforage.clear();
    }

    localStorage.setItem("loadedNewStorage", true);

    if (forceRefresh) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.append("refresh", true);
      window.location.search = searchParams.toString();
    }

    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(new Error(error));
  }
};
